import React from "react";
import {showMultiLingualText} from "@/utils/LanguageUtils";
import ListItemTemplate from "@/components/ListItemTemplate";

const ListItem = ({ pointId, point, onClick }) => {

    return (
        <div onClick={() => onClick(point.data, false)} className="w-full overflow-hidden cursor-pointer">
            <ListItemTemplate
                icon={point?.data.icon?.preview_url}
                image={point?.data.image?.preview_url}
                title={showMultiLingualText(point.data.title, null, true)}
                description={showMultiLingualText(point.data.description, null, true)}
            />
        </div>

    );

}
export default ListItem;
